<template >
  <div class="component-container">
    <app-navigation v-if="!$props.onlyMaps"></app-navigation>
      <div class="main-div">
        <div class="demo">
          <div class="p-2 header">
            <h3 class="text-left">Newsletter Subscripers</h3>
          </div>
          <table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Email</th>
      <th scope="col">Mobile</th>
      <th scope="col">Date</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(user, index) in users" :key="index">
      <th scope="row">{{index + 1}}</th>
      <td>{{user.email}}</td>
      <td>{{user.mobile}}</td>
      <td>{{user.date}}</td>
    </tr>
  </tbody>
</table>
        </div>
      </div>
  </div>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import logOut from "../scripts/utils";

export default {
  props: ["onlyMaps"],
  name: "Demo",

  data() {
    return {
    users:[],
      formState: {
        loading: false,
        error: null,
      },
    };
  },
  mounted() {
    this.getNewsletterSubscripers();
  },
  methods: {
    getNewsletterSubscripers: function () {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/newsSubscripers`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.users = res[0].data.users;
          console.log(this.users);
        })
        .catch((err) => {
            console.log('====================================');
            console.log(err);
            console.log('====================================');
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Emails fetching failed, " + err.response.data.message);
          }
          // window.location.reload();
        });
    },
  },

  components: {
    appNavigation: Navigation
  },
};
</script>
<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
}
</style>